var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 56,
    viewBox: "0 0 151 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3346_34846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3346_34846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 30,
    r: 119,
    fill: "#AB2226"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 30,
    r: 119,
    fill: "#FDD203"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPopup);
export default __webpack_public_path__ + "static/media/bgPopup.ea982f8dfa773587a9aecd4ac7f74401.svg";
export { ForwardRef as ReactComponent };